export interface CallbackAttempt {
  current: Promise<string> | null;
}

/**
 * OAuth authorization codes are single-use. React StrictMode may start an
 * effect twice in development, so every mount shares exactly one exchange.
 */
export function completeCallbackOnce(
  attempt: CallbackAttempt,
  complete: () => Promise<string>,
): Promise<string> {
  if (!attempt.current) attempt.current = complete();
  return attempt.current;
}
